import { cssVar } from 'metrix-common3';

const EditIcon = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none'>
        <path
            stroke={cssVar.colorPrimary}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7'
        />
        <path
            stroke={cssVar.colorPrimary}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z'
        />
    </svg>
);

export default EditIcon;
